import { render, staticRenderFns } from "./create-write-up.vue?vue&type=template&id=cbda8f7e&scoped=true"
import script from "./create-write-up.vue?vue&type=script&lang=js"
export * from "./create-write-up.vue?vue&type=script&lang=js"
import style0 from "./create-write-up.vue?vue&type=style&index=0&id=cbda8f7e&prod&scoped=true&lang=css"
import style1 from "./create-write-up.vue?vue&type=style&index=1&id=cbda8f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbda8f7e",
  null
  
)

export default component.exports